import { styled } from '@linaria/react';
import { colors, layout, space } from '../../theme/tokens';

export const Bar = styled.div`
  flex-shrink: 0;
  position: fixed;
  bottom: var(--sticky-footer-offset-bottom, ${layout.mobileNavHeight});
  left: 0;
  right: 0;
  padding: ${space[4]};
  background: ${colors.white};
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 103;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: static;
    bottom: auto;
    padding: 0;
    padding-top: ${space[5]};
    background: none;
    box-shadow: none;
    z-index: auto;
  }
`;
